import { createSelector } from 'reselect'

export const selectNotifications = state => state.notifications
export const selectAllNotifications = createSelector(selectNotifications, state =>
  Object.values(state).sort((a, b) => b.time - a.time)
)
